import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HouseOrderGuestService } from '../house-order-guest.service';
import _ from 'lodash';

import { NzMessageService } from 'ng-zorro-antd/message';

// import { CREDENTIAL_TYPE } from '@root/config';
import { TranslateService } from '@root/shared/service/translate.service';
import { SwitchPageService } from '@root/router/component/order-detail-sidebar/switch-page.service';
import { ViewVoucherComponent } from '@root/component/view-voucher/view-voucher.component';
import { Subject } from 'rxjs';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MultiHouseCalendarService } from '@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service';

@Component({
  selector: 'host-order-guest-similar',
  templateUrl: './order-guest-similar.component.html',
  styleUrls: ['./order-guest-similar.component.scss'],
})
export class OrderGuestSimilarComponent implements OnInit, OnDestroy {
  @Input() guestId = null;
  guestList = [];

  // private currentOrderPageRaw$ = this.switchPageService.currentNodeRaw$.pipe(
  //   tap((value) => {
  //     console.log(value);
  //   })
  // );

  private destroy$ = new Subject();

  constructor(
    private guestServcie: HouseOrderGuestService,
    private t: TranslateService,
    private modal: NzModalService,
    private drawerRef: NzDrawerRef,
    private msg: NzMessageService,
    private switchPageService: SwitchPageService,
    private calendarService: MultiHouseCalendarService
  ) {}

  ngOnInit() {
    // this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();
    this.getGuestList();
  }

  getGuestList() {
    this.guestServcie
      .getSimilarClients({
        client_id: this.guestId,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.guestList = this.format(_.get(res, 'data.list'));
        }
      });
  }

  format(data) {
    // _.forEach(data, (guest) => {
    //   _.assign(guest, {
    //     idType: this.getIdType(_.get(guest, "id_type")),
    //   });
    // });
    return data;
  }

  // getIdType(value) {
  //   const item = _.find(CREDENTIAL_TYPE, { value });
  //   return item ? this.t.syncGet(item.i18nName) : null;
  // }

  merge(b_id) {
    this.modal.warning({
      // nzTitle: "房客信息将被合并，冲突的内容将以最新的数据为准。是否继续？",
      nzTitle: this.t.syncGet('warning.guest_info_will_be_merged'),
      nzOkText: this.t.syncGet('word.confirm'),
      nzCancelText: this.t.syncGet('word.cancel'),
      nzOnOk: () => this.queryMerge(b_id),
    });
  }

  queryMerge(b_id) {
    const params = {
      client_id_a: +this.guestId,
      client_id_b: b_id,
    };
    this.guestServcie.mergeSimilarGuest(params).subscribe((res) => {
      if (res.error_code === 0) {
        const successText = this.t.syncGet('success.guest_merged');
        this.msg.success(successText);
        this.getGuestList();
      }
    });
  }

  showCredentials(data) {
    if (data.length === 0) {
      return;
    }
    const list = [];
    _.forEach(data, (info) => {
      list.push({
        url: _.get(info, 'urls.large_url'),
      });
    });
    this.modal.create({
      nzTitle: this.t.syncGet('word.credentials'),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  showItem(value) {
    return value === '' || value === null ? false : true;
  }

  jumpBack() {
    this.switchPageService.back();

    /** @deprecated */
    // this.switchPageService.deleteNodeAndUpdateCurrentNode(true);
  }

  closePannel() {
    this.drawerRef.close();

    // this.switchPageService.go(0);
    this.calendarService.cancelSelectReservation();
    // this.switchPageService.destroyCurrentLianBiao();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
